import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { colEnvs } from "@/tz/go/egaz/osci/colt/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { lpcoEnvs } from "@/tz/go/egaz/osci/lpco/comn";

/*
 * GFS Code Management Service
 * !== GFS 코드 관리 기능 서비스 ==!
 */

export const BASE = {
    path: `${lpcoEnvs.base}/colt/intf`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/colt/mgmt/gfs`,
    nodes: [
        { path: "/", label: "Collection" },
        { path: "/mgmt", label: "Collection Management" },
        { path: "/mgmt/gfs", label: "GFS Code Management" },
    ],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0406005q: `${BASE.path}/osci0406005q`, // GFS Code List !== GFS 코드 목록 ==!
    osci0406006q: `${BASE.path}/osci0406006q`, // GFS Code Detail !== GFS 코드 상세 ==!
    osci0406007s: `${BASE.path}/osci0406007s`, // GFS Code Registration !== GFS 코드 등록 ==!
    osci0406008s: `${BASE.path}/osci0406008s`, // GFS Excel Registration !== GFS 엑셀 등록 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Get GFS Code List !== GFS 코드 목록 조회 ==!
    getGfsCdList: (data: any, page: number, size: number) => {
        console.log(`${BASE.api}`);
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Get GFS Code(detail) !== GFS 코드 조회(detail) ==!
    getGfsCd: (id: any) => {
        return api.get(`${BASE.api}/${id}`);
    },
    // Delete GFS Code !== GFS 코드 삭제 ==!
    deleteGfsCd: (gfsCds: any) => {
        return api.delete(`${BASE.api}/${gfsCds}`);
    },
    // Save GFS Code !== GFS 코드 저장 ==!
    saveGfsCd: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Save GFS Excel Upload !== GFS 엑셀 업로드 저장 ==!
    saveGfsExclUpld: (data: any) => {
        return api.post(`${BASE.api}/gfsExclUpld`, {
            ...data,
        });
    },
    // setExcelUpload: (data: any) => {
    //     return api.post(
    //         `${BASE.api}/excelupload`,
    //         {
    //             ...data,
    //         },
    //         {
    //             headers: { "Content-Type": "multipart/form-data", charset: "utf-8" },
    //         },
    //     );
    // },
};

/*
 * @ 그리드 스키마 정의
 * @ 화면에서 사용하는 그리드 구조 정의
 * @ SG_ 로 시작 (Schema grid)
 * @ SG_[그리드명과 조회하는 데이터 이름 메타 단어(용어) 대문자, "_" 로 구분 , 그리드명 맨 뒤에 "_LIST" 로 종료]
 */

// Schema of GFS Code List Grid !== GFS 코드 목록 그리드 스키마 ==!
export const SG_GFS_CD_LIST: TGridSchema = {
    id: "grid_gfsCd",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: "auto",
    },
    head: [
        { cells: [{ header: "L_GFS_CD", binding: "gfsCd", width: 150 }], id: "gfsCd" },
        { cells: [{ header: "L_GFS_DESC", binding: "gfsDesc", width: "3*" }] },
        { cells: [{ header: "L_RGSR_DT", binding: "frstRgsrDt", width: "*" }] },
    ],

    body: [
        { cells: [{ binding: "gfsCd" }] },
        { cells: [{ binding: "gfsDesc", align: "left" }] },
        { cells: [{ binding: "frstRgsrDt", type: "date" }] },
    ],
};

/*
 * @ Form 스키마 정의
 * @ 화면에서 사용하는 Form 구조 정의
 * @ SF_ 로 시작 (Schema form)
 * @ SF_[Form 이름 메타 대문자, "_" 로 구분 ]
 * @ 검색폼은 _SRCH 로 구분
 */

// Schema of GFS Code List Search Form !== GFS 코드 목록 검색 폼 스키마 ==!
export const SF_GFS_CD_LIST_SRCH: TFormSchema = {
    id: "form_GfsCdListSrch",
    schema: {
        gfsCd: {
            type: "text",
            label: "L_GFS_CD",
            mask: [/\d/, ".", /\d/, ".", /\d/, ".", /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/],
            placeholder: "0.0.0.0.00.00",
        },
        rgsrDtmRnge: {
            type: "daterange",
            label: "L_RGSR_DT",
            start: { name: "strtDt" },
            end: { name: "endDt" },
            rangeButton: 0,
            controlSize: 10,
        },
    },
};

// Schema of GFS Code Form !== GFS 코드 폼 스키마 ==!
export const SF_GFS_CD: TFormSchema = {
    id: "form_gfsCd",
    schema: {
        gfsCd: {
            type: "text",
            label: "L_GFS_CD",
            mask: [/\d/, ".", /\d/, ".", /\d/, ".", /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/],
            placeholder: "0.0.0.0.00.00",
            required: true,
            minLength: 13,
        },
        gfsDesc: {
            type: "text",
            label: "L_GFS_DESC",
        },
        frstRgsrDt: {
            type: "date",
            label: "L_RGSR_DT",
        },
    },
};

// Schema of GFS Code Excel Upload Registration Grid !== GFS 코드 엑셀 업로드 등록 그리드 스키마 ==!
export const SG_GFS_EXCL_UPLD_RGSR: TGridSchema = {
    id: "grid_gfsExclUpldRgsr",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: true, //체크박스 보이기 숨기기, default : false
        pagination: "in", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        edit: true, // 그리드 편집 가능 여부 , default : false
        importExcel: true,
        height: "auto",
    },
    head: [
        { cells: [{ header: "L_GFS_CD", binding: "gfsCd", required: true, width: "10%" }] },
        { cells: [{ header: "L_GFS_DESC", binding: "gfsDesc", width: "*" }] },
    ],

    body: [
        {
            cells: [
                {
                    binding: "gfsCd",
                    placeholder: "00000000",
                    mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
                    excel: "A",
                    required: true,
                    // The length is counted with the dots, because the excel value keeps them
                    // !== 엑셀 값엔 점이 남아 있어 길이는 점을 포함해 센다 ==!
                    minLength: 8,
                    maxLength: 13,
                },
            ],
        },
        { cells: [{ binding: "gfsDesc", excel: "B" }] },
    ],
};
